// Partnerships.js
// REVIEW REQUIRED: Ivipass has not supplied any list of partner institutions or
// employers. Copy below deliberately claims no partnership, accreditation or
// network. The country tiles are presented as destinations we are asked about.
// A human must confirm before any partnership language is reinstated.
import React from 'react';
import { motion } from 'framer-motion';

const Partnerships = () => {
  const countries = [
    { name: 'United States', image: 'usa.jpg' },
    { name: 'Canada', image: 'canada.jpg' },
    { name: 'United Kingdom', image: 'uk.jpg' },
    { name: 'Australia', image: 'australia.jpg' },
    { name: 'Europe', image: 'europe.jpg' }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
            Where We Work
          </h2>
          <p className="text-gray-600 text-sm font-light max-w-3xl mx-auto mb-8">
            Enquiries reach us about destinations all over the world. These are the ones people ask about most often:
          </p>
        </motion.div>

        {/* Countries Grid */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-12">
            {countries.map((country, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.3 + (index * 0.05) }}
                className="bg-surface p-6 text-center hover:bg-white hover:shadow-md transition-all border border-transparent hover:border-secondary/20"
              >
                <div className="w-12 h-12 mx-auto mb-3 rounded-full overflow-hidden shadow-md">
                  <img 
                    src={require(`../../assets/countries/${country.image}`)} 
                    alt={country.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="text-sm font-normal text-gray-700">
                  {country.name}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Bottom Text */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="max-w-3xl mx-auto"
        >
          <p className="text-gray-700 text-sm font-light leading-relaxed text-center">
            Knowing a destination well helps us prepare an application properly, arrange interviews where that applies, and explain what a candidate is realistically looking at. Whether a place is offered, and whether a job is given, is decided by the institution or the employer alone.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Partnerships;
